<div class="integer-field" [ngClass]="state()" [class.is-disabled]="disabled()">
  <label class="integer-field-container">
    <input 
      class="integer-field-input" 
      type="text" 
      mask="separator.0" 
      [outputTransformFn]="toString" 
      [placeholder]="placeholder()" 
      [(ngModel)]="value"
      (ngModelChange)="onChangeValue($event)"
      [min]="min()"
      [max]="max()"
      [name]="name()"
      [disabled]="disabled()" 
      (blur)="blurred.emit(value())"
    >
  </label>
  @if (alert() && state() !== fieldState.Default) {
    <div class="integer-field-alert">
      <ui-inline-svg class="integer-field-alert-icon" [name]="alertIcon()"></ui-inline-svg>
      <span class="integer-field-alert-integer">{{ alert() }}</span>
    </div>
  }
</div>